import ITabMenuContentSection from "./ITabMenuContentSection";
import { ItemType } from "./ITabMenuContentItem";
import { getApiDocSection } from "./IDocSection";

const QmlativDocsMenu: Array<ITabMenuContentSection> = [
  {
    title: "Guides",
    items: [
      {
        name: "API",
        type: ItemType.doc,
        href: "/docs?id=qmlativ/general/guides/index.html",
        exactMatches: ["/docs", "/docs/"],
        startMatches: ["/docs?id=qmlativ/general/guides/"],
        docSection: {
          section: "API Guides",
          headerMenu: [
            {
              name: "API Guides",
              href: "/docs?id=qmlativ/general/guides/index.html",
              alwaysSelected: true,
            },
          ],
        },
      },
      {
        name: "ECommerce",
        type: ItemType.doc,
        href: "/docs?id=qmlativdocs/ecommerce/index.html",
        startMatches: ["/docs?id=qmlativdocs/ecommerce/"],
        docSection: {
          section: "ECommerce Guides",
          headerMenu: [
            {
              name: "ECommerce Guides",
              href: "/docs?id=qmlativdocs/ecommerce/index.html",
              alwaysSelected: true,
            },
          ],
        },
      },
      {
        name: "Single Sign On",
        type: ItemType.doc,
        href: "/docs?id=qmlativdocs/sso/index.html",
        startMatches: ["/docs?id=qmlativdocs/sso/"],
        docSection: {
          section: "SSO Guides",
          headerMenu: [
            {
              name: "SSO Guides",
              href: "/docs?id=qmlativdocs/sso/index.html",
              alwaysSelected: true,
            },
          ],
        },
      },
    ],
  },
  {
    title: "API",
    items: [
      {
        name: "OneRoster®",
        type: ItemType.api,
        href: "/docs?id=qmlativ/restapi/api/oneroster/index.html",
        startMatches: ["/docs?id=qmlativ/restapi/api/oneroster/", "/try-it-out/qmlativ/oneroster"],
        docSection: getApiDocSection("API", "Qmlativ", "Qmlativ", "OneRoster"),
      },
      {
        name: "Time Tracking",
        type: ItemType.api,
        href: "/docs?id=qmlativ/restapi/api/timetracking/index.html",
        startMatches: ["/docs?id=qmlativ/restapi/api/timetracking/", "/try-it-out/qmlativ/timetracking"],
        docSection: getApiDocSection("API", "Qmlativ", "Qmlativ", "timetracking"),
      },
      {
        name: "Online Payment",
        type: ItemType.api,
        href: "/docs?id=qmlativ/restapi/api/onlinepayment/index.html",
        startMatches: ["/docs?id=qmlativ/restapi/api/onlinepayment/", "/try-it-out/qmlativ/onlinepayment"],
        docSection: getApiDocSection("API", "Qmlativ", "Qmlativ", "onlinepayment"),
      },
      {
        name: "Identification",
        type: ItemType.api,
        href: "/docs?id=qmlativ/restapi/api/identification/index.html",
        startMatches: ["/docs?id=qmlativ/restapi/api/identitification/", "/try-it-out/qmlativ/identitification"],
        docSection: getApiDocSection("API", "Qmlativ", "Qmlativ", "identification"),
      },
      {
        name: "Attendance",
        type: ItemType.api,
        href: "/docs?id=qmlativ/restapi/api/attendance/index.html",
        startMatches: ["/docs?id=qmlativ/restapi/api/attendance/", "/try-it-out/qmlativ/attendance"],
        docSection: getApiDocSection("API", "Qmlativ", "Qmlativ", "attendance"),
      },
      {
        name: "Custom",
        type: ItemType.api,
        href: "/docs?id=qmlativ/restapi/api/custom/index.html",
        startMatches: ["/docs?id=qmlativ/restapi/api/custom/", "/try-it-out/qmlativ/custom"],
        docSection: getApiDocSection("API", "Qmlativ", "Qmlativ", "custom"),
      },
      {
        name: "Enrollment",
        type: ItemType.api,
        href: "/docs?id=qmlativ/restapi/api/enrollment/index.html",
        startMatches: ["/docs?id=qmlativ/restapi/api/enrollment", "/try-it-out/qmlativ/enrollment"],
        docSection: getApiDocSection("API", "Qmlativ", "Qmlativ", "enrollment"),
      },
      {
        name: "Special Education",
        type: ItemType.api,
        href: "/docs?id=qmlativ/restapi/api/specialeducation/index.html",
        startMatches: ["/docs?id=qmlativ/restapi/api/specialeducation", "/try-it-out/qmlativ/specialeducation"],
        docSection: getApiDocSection("API", "Qmlativ", "Qmlativ", "specialeducation"),
      },
    ],
  },
  {
    title: "Dev Kits",
    items: [
      {
        name: ".NET SDK",
        type: ItemType.code,
        href: "/docs?id=qmlativ/sdk/download.html",
        startMatches: ["/docs?id=qmlativ/sdk/"],
        docSection: {
          section: "Dev Kits",
          headerMenu: [
            {
              name: "Download",
              href: "/docs?id=qmlativ/sdk/download.html",
              startsWith: "/docs?id=qmlativ/sdk/download.html",
            },
            {
              name: "Guides",
              href: "/docs?id=qmlativ/sdk/guides/index.html",
              startsWith: "/docs?id=qmlativ/sdk/guides/",
            },
            {
              name: "Reference",
              href: "/docs?id=qmlativ/sdk/api/index.html",
              startsWith: "/docs?id=qmlativ/sdk/api/",
            },
          ],
        },
      },
    ],
  },
];

export default QmlativDocsMenu;
